"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMeta = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {};
const metaSlice = (0, toolkit_1.createSlice)({
    name: 'meta',
    initialState,
    reducers: {
        setMeta: (_state, action) => {
            if (!action.payload)
                return;
            Object.entries(action.payload).forEach((entry) => {
                _state[entry[0]] = entry[1];
            });
        },
    },
});
exports.setMeta = metaSlice.actions.setMeta;
exports.default = metaSlice.reducer;
